// HotelDetailsSection.tsx
import React from "react";
import { Col, Row } from "react-bootstrap";
import IHotel from "../../../../@types/IHotel";
import ILocation from "../../../../@types/ILocation";
import { StyledContainer } from "../../HotelPageHelpers";
import Title2 from "../../../../components/global/Title2/Title2";
import FeaturesTabs from "../../../../components/common/FeaturesTabs/FeaturesTabs";
import { textLeft, textRight } from "./HotelDetailsSection.module.scss";
import { Helmet } from "react-helmet";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";

interface HotelDetailsSectionProps {
  features: any[];
  renderedFeatures: any[];
  isWebFramed: boolean;
  hotel: IHotel;
  location: ILocation;
  isMetaHotelDetails?: boolean;
  handleCloseModal?: () => void;
}

const HotelDetailsSection: React.FC<HotelDetailsSectionProps> = ({
  features,
  renderedFeatures,
  isWebFramed,
  hotel,
  location,
  isMetaHotelDetails = false,
  handleCloseModal,
}) => {
  if (features === null || !renderedFeatures.length) {
    return null;
  }

  return (
    <StyledContainer
      className={`${
        !isMetaHotelDetails
          ? "bg-light hotelGlobalContainer pt-4 pt-lg-5"
          : "pt-3"
      } position-relative ${isWebFramed ? "mb-4 mb-lg-5 pb-4 pb-lg-5" : ""}`}
      fluid={true}
    >
      <Helmet>
        <script src="https://www.speedrfp.com/irfps/js/widget/"></script>
      </Helmet>
      <>
        <a
          className="anchor-target visually-hidden"
          id="hoteldetails"
          aria-hidden={true}
        />
        <StyledContainer fluid="sm">
          <>
            <Row>
              <Col
                className={`${
                  !isMetaHotelDetails ? "text-center" : ""
                }text-lg-start featureCol`}
              >
                <div id={"about-the-hotel"} className="subTitle">
                  <Row>
                    <Col className={`${isMetaHotelDetails ? textLeft : ""}`}>
                      About The Hotel
                    </Col>
                    {isMetaHotelDetails && (
                      <Col className={textRight}>
                        <span
                          role="button"
                          tabIndex={0}
                          onClick={handleCloseModal}
                          onKeyDown={(e) => {
                            if (e.key === "Enter" || e.key === " ") {
                              handleCloseModal && handleCloseModal();
                            }
                          }}
                          aria-label="Close modal"
                        >
                          <FontAwesomeIcon icon={faTimes} size="lg" />
                        </span>
                      </Col>
                    )}
                  </Row>
                </div>
                <Title2 id="hotel-details-title">Hotel Details</Title2>
              </Col>
            </Row>
            <FeaturesTabs
              features={renderedFeatures}
              gallery={null}
              hotel={hotel}
              location={location}
            />
          </>
        </StyledContainer>
      </>
    </StyledContainer>
  );
};

export default HotelDetailsSection;
